module.exports = __webpack_public_path__ + "static/img/incubator_videopreview_mobile.2dfceda.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/incubator_videopreview_mobile.png
// module id = FlMO
// module chunks = 1